/**
 * Theme Typography Configuration
 * Typography system for MUI theme
 */

import { typography as typographyTokens } from '../tokens/dimensions';

const fontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
const fontFamilyMono = '"Roboto Mono", "Courier New", monospace';

export const typography = {
  fontFamily,
  fontFamilyMono,
  
  // Font sizes are defined but we'll override most components to use proper sizing
  fontSize: 14, // Base font size (0.875rem * 16) - Industry standard
  
  // Standard MUI variants with proper sizing
  h1: {
    fontSize: typographyTokens.fontSize['2xl'],
    fontWeight: typographyTokens.fontWeight.bold,
    lineHeight: typographyTokens.lineHeight.tight,
  },
  
  h2: {
    fontSize: typographyTokens.fontSize.xl,
    fontWeight: typographyTokens.fontWeight.bold,
    lineHeight: typographyTokens.lineHeight.tight,
  },
  
  h3: {
    fontSize: typographyTokens.fontSize.lg,
    fontWeight: typographyTokens.fontWeight.semibold,
    lineHeight: typographyTokens.lineHeight.snug,
  },
  
  h4: {
    fontSize: typographyTokens.fontSize.md,
    fontWeight: typographyTokens.fontWeight.semibold,
    lineHeight: typographyTokens.lineHeight.snug,
  },
  
  h5: {
    fontSize: typographyTokens.fontSize.base,
    fontWeight: typographyTokens.fontWeight.semibold,
    lineHeight: typographyTokens.lineHeight.normal,
  },
  
  h6: {
    fontSize: typographyTokens.fontSize.base,
    fontWeight: typographyTokens.fontWeight.medium,
    lineHeight: typographyTokens.lineHeight.normal,
  },
  
  subtitle1: {
    fontSize: typographyTokens.fontSize.base,
    fontWeight: typographyTokens.fontWeight.medium,
    lineHeight: typographyTokens.lineHeight.normal,
  },
  
  subtitle2: {
    fontSize: typographyTokens.fontSize.sm,
    fontWeight: typographyTokens.fontWeight.medium,
    lineHeight: typographyTokens.lineHeight.normal,
  },
  
  body1: {
    fontSize: typographyTokens.fontSize.md, // 16px - MUI default
    fontWeight: typographyTokens.fontWeight.regular,
    lineHeight: typographyTokens.lineHeight.normal,
  },
  
  body2: {
    fontSize: typographyTokens.fontSize.base, // 14px - MUI default
    fontWeight: typographyTokens.fontWeight.regular,
    lineHeight: typographyTokens.lineHeight.normal,
  },
  
  button: {
    fontSize: typographyTokens.fontSize.base, // 14px - MUI default
    fontWeight: typographyTokens.fontWeight.medium,
    lineHeight: typographyTokens.lineHeight.normal,
    textTransform: 'none', // Override MUI default uppercase
  },
  
  caption: {
    fontSize: typographyTokens.fontSize.sm,
    fontWeight: typographyTokens.fontWeight.regular,
    lineHeight: typographyTokens.lineHeight.snug,
  },
  
  overline: {
    fontSize: typographyTokens.fontSize.xs,
    fontWeight: typographyTokens.fontWeight.semibold,
    lineHeight: typographyTokens.lineHeight.normal,
    textTransform: 'uppercase',
    letterSpacing: typographyTokens.letterSpacing.wider,
  },
  
  // Custom variants for our app
  sectionLabel: {
    fontSize: typographyTokens.fontSize.base,
    fontWeight: typographyTokens.fontWeight.semibold,
    lineHeight: typographyTokens.lineHeight.normal,
    textTransform: 'uppercase',
    letterSpacing: typographyTokens.letterSpacing.wide,
    color: 'text.secondary',
  },
  
  helperText: {
    fontSize: typographyTokens.fontSize.sm,
    fontWeight: typographyTokens.fontWeight.regular,
    lineHeight: typographyTokens.lineHeight.snug,
    color: 'text.secondary',
  },
  
  code: {
    fontFamily: fontFamilyMono,
    fontSize: typographyTokens.fontSize.sm,
    fontWeight: typographyTokens.fontWeight.regular,
    lineHeight: typographyTokens.lineHeight.normal,
  },
};